import { call } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client/pkg/request';
import { getBackgrounds } from './_fixtures';
export function* doFetchBackgrounds(offset, limit) {
    const params = {
        offset,
        limit
    };
    const result = yield call(requestPuppy, {
        method: 'get',
        url: 'backgrounds',
        params
    }, ()=>{
        return {
            results: getBackgrounds(),
            hasMore: false
        };
    }, 'dadeviation');
    return result;
}
export function* doSetBackground(deviationid, backgroundid) {
    const data = {
        deviationid,
        backgroundid
    };
    const result = yield call(requestPuppy, {
        method: 'post',
        url: 'set_background',
        data
    }, ()=>{
        return {
            success: true
        };
    }, 'dadeviation');
    return result;
}
